import { motion } from "framer-motion";
import { BUSINESS } from "@/config";

const stats = [
  ["30+", "Years In Trade"],
  ["2011", "Established"],
  ["Domestic", "& Commercial"],
];

const AboutConan = () => {
  return (
    <section
      id="about-conan"
      className="relative py-20 md:py-28 bg-[#0B132B] overflow-hidden"
      data-testid="about-conan-section"
    >
      {/* faint springbok mark, far right */}
      <div
        className="absolute -right-12 top-1/2 -translate-y-1/2 pointer-events-none hidden md:block"
        aria-hidden
      >
        <img
          src={BUSINESS.springbokUrl}
          alt=""
          className="h-[60vh] w-auto opacity-[0.05]"
          draggable={false}
        />
      </div>

      <div className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.p
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.5 }}
          className="text-xs uppercase tracking-[0.3em] text-[#D47A4A] mb-4"
        >
          / 03 — About
        </motion.p>

        <motion.h2
          initial={{ opacity: 0, y: 14 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="font-display text-4xl md:text-6xl text-white leading-[0.95] tracking-tight"
        >
          ABOUT
          <br />
          <span className="text-[#D47A4A]">CONAN SHARMAN.</span>
        </motion.h2>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="mt-10 grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-12 items-start"
        >
          <div className="md:col-span-8 space-y-5 text-base md:text-lg text-[#A0ABC0] leading-relaxed">
            <p>
              Conan Sharman has been working in the plumbing and drainage trade
              for over <span className="text-white">30 years</span>, building a
              reputation across Edinburgh and the Lothians for honest,
              professional and reliable work.
            </p>
            <p>
              Established in 2011,{" "}
              <span className="text-white">
                Conan Sharman Plumbing and Drain Cleaning Ltd
              </span>{" "}
              has grown into a trusted name for both domestic and commercial
              clients — from small household repairs to larger projects requiring
              full coordination and subcontractor management.
            </p>
            <p>
              Whether it's a straightforward fix or a complex job, every project
              is approached with the same commitment to quality and getting it
              done right.
            </p>
          </div>

          <div className="md:col-span-4 space-y-4">
            {stats.map(([num, label]) => (
              <div
                key={label}
                className="bg-[#151D33] border border-[#2C374D] hover:border-[#D47A4A]/60 transition-colors p-5 rounded-sm"
                data-testid={`about-stat-${label.replace(/\s+/g, "-").toLowerCase()}`}
              >
                <div className="font-display text-3xl md:text-4xl text-white tracking-wide">
                  {num}
                </div>
                <div className="text-xs uppercase tracking-[0.22em] text-[#D47A4A] mt-1">
                  {label}
                </div>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default AboutConan;
